import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useDeDeleteLegalGuardianAttestationMutation as useDeDeleteLegalGuardianAttestationMutationType } from "@/modules/patients/detail/legal-guardian-attestation/de/services/__generated__/useDeDeleteLegalGuardianAttestationMutation.graphql"

const mutation = graphql`
  mutation useDeDeleteLegalGuardianAttestationMutation($input: De_deleteAttestationGuardianInput!) {
    de_deleteAttestationGuardian(input: $input) {
      de_AttestationGuardian {
        id @deleteRecord
      }
    }
  }
`

const useDeDeleteLegalGuardianAttestationMutation = () => {
  const [commit, isFlight] = useMutation<useDeDeleteLegalGuardianAttestationMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeDeleteLegalGuardianAttestationMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeDeleteLegalGuardianAttestationMutation }
